import {Directive, ElementRef, EventEmitter, HostListener, Input, Optional, Output, Renderer2} from '@angular/core';


@Directive({
  selector: '[libHome365Link]'
})
export class Home365LinkDirective {
  private _noLink = false;
  @Output() execute: EventEmitter<PointerEvent | KeyboardEvent> = new EventEmitter<PointerEvent | KeyboardEvent>();

  @Input() set disabled(value: boolean) {
    if (value) {
      this.disable();
    } else {
      this.enable();
    }
  }

  @Input() set noLink(value: boolean) {
    if (value) {
      this._removeLinkClass();
    } else if (!value) {
      this._addLinkClass();
    }
    this._noLink = value;
  }

  @HostListener('click', ['$event']) onClick(event: PointerEvent) {
    if (!this._noLink) {
      this.execute.emit(event);
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (!this._noLink && event.key === 'Enter') {
      this.execute.emit(event);
    }
  }

  constructor(private el: ElementRef, private renderer: Renderer2, @Optional() private __config: Home365LinkConfig) {
    if (!this._config.disabled) {
      this._addLinkClass();
    } else {
      this._noLink = true;
    }
  }

  private get _config(): Home365LinkConfig {
    return this.__config ?? new Home365LinkConfig(false);
  }

  private _addLinkClass() {
    this.renderer.addClass(this.el.nativeElement, 'as-link');
    this.renderer.addClass(this.el.nativeElement, 'home365-link');
    this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0');
  }

  private _removeLinkClass() {
    this.renderer?.removeClass(this.el.nativeElement, 'as-link');
    this.renderer?.removeClass(this.el.nativeElement, 'home365-link');
    this.renderer?.removeAttribute(this.el.nativeElement, 'tabindex');
  }

  disable() {
    this.renderer.addClass(this.el.nativeElement, 'disabled');
  }

  enable() {
    this.renderer?.removeClass(this.el.nativeElement, 'disabled');
  }
}

export class Home365LinkConfig {
  constructor(public disabled: boolean) {
  }
}
